import React, { useEffect, useState } from "react";
import { AddressIcpLookupField } from "./AddressIcpLookupField";
import { FlexGrowProps } from "styled-system";
import { Address } from "../../types/Address";
import lookupIcpAddress from "../../services/AddressIcpService";

export interface AddressIcpLookupFieldProps {
  id: string;
  icpNumber: string;
  validateField: (field: string) => void;
}

const ICP_LENGTH = 15;
const EMPTY_ADDRESS: Address = {
  id: "",
  label: "",
};

export const AddressIcpLookupFieldContainer: React.FC<
  AddressIcpLookupFieldProps & FlexGrowProps
> = ({ id, icpNumber, validateField }) => {
  const [addressLookup, setAddressLookup] = useState<Address>(EMPTY_ADDRESS);
  const [unknownIcp, setUnknownIcp] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAddress = async () => {
      setAddressLookup(EMPTY_ADDRESS);
      setUnknownIcp(false);
      if (icpNumber?.length === ICP_LENGTH) {
        setLoading(true);
        const address = await lookupIcpAddress(icpNumber);
        if (address.label) {
          setAddressLookup(address);
        } else {
          setUnknownIcp(true);
        }
      }
      setLoading(false);
    };
    fetchAddress();
  }, [icpNumber]);

  return (
    <AddressIcpLookupField
      id={id}
      icpNumber={icpNumber}
      addressLabel={addressLookup.label}
      unknownIcp={unknownIcp}
      loading={loading}
      validateField={validateField}
    />
  );
};
